module.exports = __webpack_public_path__ + "img/Loaderverify.1b6ba400.gif";